module.exports = __webpack_public_path__ + "static/media/icon.35251cc7.svg";